export default __webpack_public_path__ + "static/18-city-e8029c83be6d735c3d83a0b814065017.png";